import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Guards /admin/* routes - only users with the Admin role can pass
const RequireAdmin = ({ children }) => {
    const { user, isAdmin } = useAuth();

    if (!user) return <Navigate to="/login" replace />;
    if (!isAdmin) return <Navigate to="/" replace />;

    return children;
};

export default RequireAdmin;
